import React from "react";
import { Link, useLocation } from "react-router-dom";

const ServiceCategoryNavbar = () => {
  const location = useLocation(); // Get current path

  return (
    <div className="text-start mb-2 catnav">
      <Link
        className={`nacs catitm me-2 ${location.pathname === "/admin/all-service-category" ? "activecat" : ""}`}
        to="/admin/all-service-category"
        data-discover="true"
      >
       All Service Category
      </Link>



      <Link
        className={`nacs catitm me-2 ${location.pathname === "/admin/service-category" ? "activecat" : ""}`}
        to="/admin/service-category"
        data-discover="true"
      >
        What we do
      </Link>

      <Link
        className={`nacs catitm me-2 ${location.pathname === "/admin/category" ? "activecat" : ""}`}
        to="/admin/category"
        data-discover="true"
      >
       Category 
      </Link>


      <Link
        className={`nacs catitm me-2 ${location.pathname === "/admin/sub-category-service" ? "activecat" : ""}`}
        to="/admin/sub-category-service"
        data-discover="true"
      >
       Sub Category
      </Link>


      <Link
        className={`nacs catitm me-2 ${location.pathname === "/admin/sub-sub-category-service" ? "activecat" : ""}`}
        to="/admin/sub-sub-category-service"
        data-discover="true"
      >
       Sub Sub Category
      </Link>


{/* 
      <Link
        className={`nacs catitm me-2 ${location.pathname === "/admin/state-city-service" ? "activecat" : ""}`}
        to="/admin/state-city-service"
        data-discover="true"
      >
        State
      </Link> */}


      {/* <Link
        className={`nacs catitm me-2 ${location.pathname === "/admin/city-service" ? "activecat" : ""}`}
        to="/admin/city-service"
        data-discover="true"
      >
        City
      </Link> */}

 
      {/* <Link
        className={`nacs catitm me-2 ${location.pathname === "/admin/ten-category" ? "activecat" : ""}`}
        to="/admin/ten-category"
        data-discover="true"
      >
        10th Level Category
      </Link> */}

      
      

      
      


    </div>
  );
};

export default ServiceCategoryNavbar;
